import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/abstractuploadServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { validateFile} from '../../utils/validators';

const Abstractupload = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
    abs_deadline_title: '',
    abs_deadline_date: '',
  });

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
     try { 
    const response = await getData();
    if (response.data.length > 0) {
      setFormData(response.data[0]); // Load first record into the form
    }
  }
  catch (error) { 
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

   //validate the form 
    const validateForm = () => {
    const newErrors = {};
    if (!formData.abs_deadline_title) newErrors.abs_deadline_title = "Deadline Title is required";
    if (!formData.abs_deadline_date) newErrors.abs_deadline_date = "Deadline Date is required";
    if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Upload File is required";
  }
   setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

  // Handle input changes
  const handleChange = async(e) => {
    try{
            const { name, value, files } = e.target;
            const file = files?.[0]
              // Create a copy of the current form data
              let updatedData = { ...formData };
              let updatedErrors = { ...errors };
              if (file) {
                const isDOC = file.type === "application/msword"||"application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                if (!isDOC) {
                  setErrors((prev) => ({
                    ...prev,
                    [name]: "Only word format files are allowed.",
                  }));
                  return;
                }
                  let fileType = "";
                  if (file.type.includes("image")) {
                    fileType = "img";
                  } else if (file.type === "application/pdf") {
                    fileType = "pdf";
                  } else if (
                    file.type === "application/msword" ||
                    file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  ) {
                    fileType = "word";
                  } else {
                    fileType = "unknown"; // optional
                  }
                  // const fileType = file.type.includes("image") ? "img" : "pdf";
                  const isValid = await validateFile(file, setErrors,name,fileType);
                  if (isValid) {
                    updatedData[name] = file;
                    updatedErrors[name] = '';
                  }
                  else{
                    return ; // Don't update if invalid
                  }
            } 
              else{
              updatedData[name] = value;
              if (value) {
              updatedErrors[name] = ''; // Clear error if corrected
            }}
            setFormData(updatedData);
            setErrors(updatedErrors);
          }
          catch (error) {
          console.error("Error in handleChange:", error);
        }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate form data
      if (!validateForm()) {
          return
        }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('abs_deadline_title', formData.abs_deadline_title);
    form.append('abs_deadline_date', formData.abs_deadline_date);
    form.append('uploadedfile', formData.uploadedfile);
    

    const result = await updateData(form);
    if (result.status === 200) {
      fetchData(); // Refresh data after update
      toast.success("Saved Successfully!", {position: 'top-right',});
    } else {
      toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right'});
    }
  }
  catch (error) {
        console.error("Error during form submission:", error);
    }
  
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Basic Setup & File upload <b>/ Sample Abstract</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
          

          {/* Editable Form (Always Visible) */}
          <div className="card p-3 mb-4">
            {/* <h4 className='mb-3'>Edit Abstract</h4> */}
            <Form onSubmit={handleSubmit}>
                <div className="row">
              <Form.Group className="col-md-3 mb-3">
                <Form.Label className='form-label-custom'>Deadline Title<small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="text"
                  name="abs_deadline_title"
                  value={formData.abs_deadline_title}
                  onChange={handleChange}
                  isInvalid={!!errors.abs_deadline_title}
                />
                <Form.Control.Feedback type="invalid">{errors.abs_deadline_title}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-md-3 mb-3">
                <Form.Label className='form-label-custom'>Deadline Date <small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="date"
                  name="abs_deadline_date"
                  value={formData.abs_deadline_date}
                  onChange={handleChange}
                  isInvalid={!!errors.abs_deadline_date}
                />
                <Form.Control.Feedback type="invalid">{errors.abs_deadline_date}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Upload File <small className='text-danger'> * </small><small className="text-primary">(Upload file size should be less than 8mb)</small></Form.Label>
                <Form.Control type="file" name="uploadedfile" onChange={handleChange} isInvalid={!!errors.uploadedfile}  accept=".doc,.docx" />
                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                  <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
              </Form.Group>
              </div>
              <Button variant="success" type="submit">Submit</Button>
            </Form>
          </div>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Abstractupload;
